import {httpClient} from '../utils/shared/http-client';

const articleHttpRepositoryContract = Object.seal({
  async get() {
    throw Error('Method get() not implemented');
  }
});

const articleHttpRepository = Object.assign(articleHttpRepositoryContract, {

  async get(articleId) {
    return await httpClient.get(`${window.Site.commentsDomain}articles/${articleId}`);
  }
});

export {
  articleHttpRepository
};
